<template lang="pug">
	div.header-particles
</template>

<script>
import ParticleController from '@/helpers/particles'
export default {
	name: 'BackgroundParticles',
	mounted () {
		if (window.screen.width > 649) {
			new ParticleController({
				numberOfParticles: 16,
				header           : document.querySelector('.header-particles')
			}).init()
		}
	}
}
</script>
